import type { FC, ReactNode } from 'react'

export const FieldsConfiguration: FC<{ children: ReactNode }> = props => {
  // props
  const { children } = props

  return (
    <section className='relative flex flex-col gap-4 bg-white mx-60 my-4 p-6 rounded-lg h-[90vh] overflow-auto'>
      <div className='flex flex-col gap-3'>
        <p className='font-bold text-main text-base'>配置说明</p>
        <p className='text-secondary-2 text-sm'>
          一份文件中可能会包含多种不同类型的字段需要抽取，每种类型的字段可选择的抽取方式和最终结果呈现存在不同。在此配置需要从文件中抽取的字段，支持多种类型的字段：文本，表格，整表，印章，手写体等
        </p>
        <div className='bg-main-bg rounded h-32'></div>
      </div>
      {children}
    </section>
  )
}

export { TabsForm } from './TabsForm'
